module.exports = __webpack_public_path__ + "img/icon_paging_prevv.50a88b69.svg";